<div class="tile">
  <h3 class="mb-3 font-size-3">{{ 'lombard.legal.headline' | transloco }}</h3>
  <p class="text-size-large" [innerHTML]="'lombard.legal.body' | transloco"></p>
</div>
